import React from 'react';
import { useDrag, useDrop } from 'react-dnd';

const ColumnWrapper = ({ column, index, moveColumn, children }) => {
  const [{ isDragging }, drag] = useDrag({
    type: 'COLUMN',
    item: { type: 'COLUMN', id: column.id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: 'COLUMN',
    hover(item, monitor) {
      if (!drag) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      moveColumn(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  return (
    <div ref={(node) => drag(drop(node))} className={`column-wrapper ${isDragging ? 'is-dragging' : ''}`}>
      {children}
    </div>
  );
};

export default ColumnWrapper;

